export class AuthService {
  public Ready: Promise<any>
  userManager: any

  constructor(authority: string) {
    this.Ready = new Promise((resolve) => {
      PDR.libraries.get('oidc-client').then((Oidc: any) => {
        const settings = {
          authority: authority,
          client_id: 'platform-portal-frontend',
          redirect_uri: `${location.origin}/callback.html`,
          silent_redirect_uri: `${location.origin}/callbackSilent.html,`,
          response_type: 'code',
          scope: 'openid stratsys.dbtooling.read user.readwrite',
          clockSkew: 400,
          automaticSilentRenew: true,
          validateSubOnSilentRenew: true,
          filterProtocolClaims: true
        }

        this.userManager = new Oidc.UserManager(settings)
        resolve(undefined)
      })
    })
  }

  public login(login_hint: string, acr_values: string): Promise<void> {
    return this.userManager.signinRedirect({
      login_hint: login_hint,
      acr_values: acr_values
    })
  }
}
